export default __webpack_public_path__ + "static/media/sp-long-equation.028a2bef.png";